import { Link } from "react-router-dom";
import { Logo } from "@/components/kit";

const TEXT = {
  termos: ["Termos de Uso", [
    ["Objeto", "O PROSPERA+ é uma plataforma SaaS de organização financeira e planejamento patrimonial com finalidade educacional. Não realiza operações financeiras, não custodia recursos e não presta consultoria de valores mobiliários."],
    ["Conta e segurança", "O usuário é responsável pela veracidade dos dados e pela guarda de suas credenciais. Senhas são armazenadas com hash bcrypt; sessões utilizam tokens com expiração."],
    ["Planos e cobrança", "Os planos Essencial, Família, Empresarial e Premium são cobrados mensalmente de forma recorrente. O cancelamento pode ser feito a qualquer momento no painel de Assinatura, interrompendo as próximas cobranças."],
    ["Limitação", "Projeções e simulações são cenários hipotéticos baseados em premissas informadas; não há garantia de rentabilidade. Decisões de investimento devem ser avaliadas com profissional habilitado."],
  ]],
  privacidade: ["Política de Privacidade (LGPD)", [
    ["Dados tratados", "Nome, e-mail, dados financeiros inseridos voluntariamente (receitas, despesas, patrimônio, dívidas, metas) e registros técnicos de acesso para segurança."],
    ["Finalidade e base legal", "Execução do contrato (art. 7º, V, LGPD) para prestar o serviço; consentimento específico (art. 7º, I) para o uso do Mentor IA, revogável a qualquer momento."],
    ["Isolamento e segurança", "Cada espaço financeiro é isolado por proprietário e membros autorizados. Administradores visualizam apenas metadados (sem valores financeiros). Ações críticas são registradas em trilha de auditoria."],
    ["Mentor IA", "Quando autorizado, um resumo calculado dos seus números é enviado a provedor de IA (OpenAI) apenas para gerar a resposta. Os cálculos são feitos pelo motor determinístico PROSPERA+."],
    ["Direitos do titular", "Acesso, portabilidade (exportação JSON), correção e exclusão definitiva da conta estão disponíveis em Privacidade & LGPD dentro do aplicativo."],
    ["Encarregado (DPO)", "Contato do encarregado: e-mail rafsp25@gmail.com · telefone e WhatsApp (11) 99642-0785."],
  ]],
};

export default function Legal({ kind }) {
  const [title, items] = TEXT[kind];
  return (
    <div className="min-h-screen bg-[#060D1A] px-5 py-12">
      <div className="mx-auto max-w-3xl">
        <Link to="/"><Logo className="mb-10 w-40 rounded-xl" testid="legal-logo" /></Link>
        <h1 className="text-3xl font-semibold" data-testid="legal-title">{title}</h1>
        <p className="mt-2 text-xs text-slate-500">Versão 2026-01 · minuta para revisão jurídica</p>
        <div className="mt-8 space-y-6">
          {items.map(([h, t]) => (
            <section key={h}><h2 className="text-lg font-semibold text-[#F5D77F]">{h}</h2><p className="mt-1 text-sm leading-relaxed text-slate-300">{t}</p></section>
          ))}
        </div>
      </div>
    </div>
  );
}
